import React from 'react';
import { motion } from 'framer-motion';

const Projects = () => {
  return (
    <section id="projects" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Our Creative projects
            </h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              We believe in the power of creative thinking and innovative design solutions. 
              Our projects showcase our ability to transform ideas into stunning digital experiences 
              that captivate audiences and drive meaningful results.
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              className="bg-pink-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-pink-600 transition-colors"
            >
              LEARN MORE
            </motion.button>
          </motion.div>

          {/* Image Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative z-10">
              {/* Main image */}
              <div className="bg-gradient-to-br from-gray-200 to-gray-300 rounded-2xl p-8 mb-4">
                <img 
                  src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=300&fit=crop" 
                  alt="Creative professional at work"
                  className="w-full h-64 object-cover rounded-xl"
                />
              </div>
              
              {/* Floating elements */}
              <div className="absolute -top-4 -left-4 bg-yellow-400 w-20 h-20 rounded-full flex items-center justify-center shadow-lg">
                <img 
                  src="https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=60&h=60&fit=crop" 
                  alt="Design mockup"
                  className="w-12 h-12 object-cover rounded-full"
                />
              </div>
              
              <div className="absolute -bottom-4 -right-4 bg-pink-500 w-16 h-16 rounded-full"></div>
              <div className="absolute top-1/2 -right-6 bg-purple-500 w-12 h-12 rounded-full"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Projects;